import React from 'react';
import Label from './Label.js';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import classNames from 'classnames';
import ArrowIcon from '../Icons/ArrowIcon.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../InfoIcon-f1b0281a.js';
import '../Icons/InfoIcon.js';

var css_248z = "._6FNNa{align-items:center;display:flex;gap:4px}[dir] ._6FNNa{cursor:pointer;margin-bottom:12px}._6FNNa *{color:var(--ricos-settings-action-color,var(--ricos-action-color,#0261ff))!important}.xlDsZ{fill:var(--ricos-settings-action-color,var(--ricos-action-color,#0261ff));max-width:22px}[dir=ltr] .xlDsZ:not(.mH8uC){padding-left:2px;transform:rotate(90deg)}[dir=rtl] .xlDsZ:not(.mH8uC){padding-right:2px;transform:rotate(-90deg)}[dir=ltr] .xlDsZ.mH8uC{padding-right:2px;transform:rotate(-90deg)}[dir=rtl] .xlDsZ.mH8uC{padding-left:2px;transform:rotate(90deg)}";
var styles = {"collapseButton":"_6FNNa","expandIcon":"xlDsZ","expanded":"mH8uC"};
styleInject(css_248z);

const CollapseButton = ({ isOpen, onClick, label, dataHook, ariaLabel }) => {
  const onKeyPress = (e) => {
    if (e.key === "Enter") {
      onClick();
    }
  };
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    /* @__PURE__ */ React.createElement(
      "div",
      {
        role: "button",
        "aria-label": ariaLabel,
        tabIndex: 0,
        className: styles.collapseButton,
        onClick,
        "data-hook": dataHook,
        onKeyPress
      },
      /* @__PURE__ */ React.createElement(Label, { label }),
      /* @__PURE__ */ React.createElement(ArrowIcon, { className: classNames(styles.expandIcon, isOpen && styles.expanded) })
    )
  );
};

export { CollapseButton as default };
//# sourceMappingURL=CollapseButton.js.map
